<template>
  <!-- Modal terms -->
  <div
    class="modal fade"
    id="commitment-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="termsLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="commitmentLabel">{{ $t('Girisimcilik.header') }}</h4>
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        </div>
        <div class="modal-body modal-body-min">
          <h5>
            {{ $t('Girisimcilik.p1') }}
          </h5>
          <p>
            {{ $t('Girisimcilik.p2') }}
          </p>
          <ul>
            <li>{{ $t('Girisimcilik.p3') }}</li>
            <li>{{ $t('Girisimcilik.p4') }}</li>
          </ul>

          <h5>{{ $t('Girisimcilik.p5') }}</h5>
          <p>{{ $t('Girisimcilik.p6') }}</p>

          <h5>{{ $t('Girisimcilik.p7') }}</h5>
          <p>{{ $t('Girisimcilik.p8') }}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-dismiss="modal" aria-hidden="true">
            {{ $t('Kapat') }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'CommitmentModal',
};
</script>
